import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useForm, Controller } from 'react-hook-form';
import { Form, Col } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { toast } from 'react-toastify';
//api
import { changePasswordIntranetUser } from 'api/users';
//components
import ModalCustom from 'components/backoffice/modals/ModalCustom';
import FooterModal from 'components/backoffice/modals/FooterModal';
import CustomInput from 'components/backoffice/customInput/index';

const ChangePassword = ({ show, setShow, id, beforeTitle }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);

  const { t } = useTranslation(['backoffice']);
  const {setTitle} = useOutletContext()
  const {
    formState: { errors },
    reset,
    control,
    handleSubmit,
    watch,
  } = useForm();

  useEffect(() => {
    if(show){
      setTitle(t('cambiarcontrasena'))
    } 
  },[show])

  const handlePassword = useCallback(async (values) => {
    setIsLoading(true);
    const data = {
      newPass: values.new_pass,
      uid: btoa(id.toString())
    };
    try {
      const { status } = await changePasswordIntranetUser(data);
      if (status === 200) {
        reset();
        toast.success(t('creadocorrectamente'));
        setShow(false);
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  }, []);

  const handleClose = () => {
    setShow(false)
    setTitle(beforeTitle)
  }

  return (
    <ModalCustom
      show={show}
      onHide={handleClose}
      title={t('cambiarcontrasena')}
      footer={<FooterModal onCancel={handleClose} onSave={handleSubmit(handlePassword)} loading={isLoading} />}
    >
      <Form onSubmit={handleSubmit(handlePassword)} className="mb-3">
        <Col>
          <Controller
            name="new_pass"
            control={control}
            rules={{
              minLength: { value: 9, message: t('caracteresminimos') },
              required: {
                value: true,
                message: t('camporequerido'),
              },
            }}
            render={({ field: { onChange, value } }) => (
              <CustomInput
                type={showNewPassword ? 'text' : 'password'}
                value={value}
                label={t('newpassword')}
                placeholder={t('newpassword')}
                onChange={(e) => onChange(e)}
                icon={
                  showNewPassword ? (
                    <FaEyeSlash onClick={() => setShowNewPassword(false)} color="black" className="icon-password" />
                  ) : (
                    <FaEye onClick={() => setShowNewPassword(true)} color="black" className="icon-password" />
                  )
                }
              />
            )}
          />
          {errors.new_pass && <small className="text-danger ">{errors.new_pass.message}</small>}
        </Col>
        <Col className="mt-5">
          <Controller
            name="repeat_pass"
            className="mt-5"
            control={control}
            rules={{
              minLength: { value: 9, message: t('caracteresminimos') },
              required: {
                value: true,
                message: t('camporequerido'),
              },
              validate: (value) => value === watch('new_pass') || t('nocoincidepassword'),
            }}
            render={({ field: { onChange, value } }) => (
              <CustomInput
                type={showRepeatPassword ? 'text' : 'password'}
                value={value}
                label={t('repeatpassword')}
                placeholder={t('repeatpassword')}
                onChange={(e) => onChange(e)}
                icon={
                  showRepeatPassword ? (
                    <FaEyeSlash onClick={() => setShowRepeatPassword(false)} color="black" className="icon-password" />
                  ) : (
                    <FaEye onClick={() => setShowRepeatPassword(true)} color="black" className="icon-password" />
                  )
                }
              />
            )}
          />
          {errors.repeat_pass && <small className="text-danger ">{errors.repeat_pass.message}</small>}
        </Col>
      </Form>
    </ModalCustom>
  );
};

ChangePassword.propTypes = {
  show: PropTypes.bool,
  setShow: PropTypes.func,
  id: PropTypes.any,
  beforeTitle: PropTypes.string
};

export default ChangePassword;
